import { render, staticRenderFns } from "./TicketActivityOld.vue?vue&type=template&id=a5fb1adc&scoped=true"
import script from "./TicketActivityOld.vue?vue&type=script&lang=js"
export * from "./TicketActivityOld.vue?vue&type=script&lang=js"
import style0 from "./TicketActivityOld.vue?vue&type=style&index=0&id=a5fb1adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fb1adc",
  null
  
)

export default component.exports